export default "__VITE_ASSET__CDIjZPtd__"